import { hexToRgbString } from '@/shared/utils/hexToRgbString';

import type { FolderColor } from '../types/folder.types';

import { folderColorHex } from './folderColor';

/**
 * 폴더 상세 상단 배너 — 폴더 색(목록의 폴더 모양과 같은 색)으로 채우다가 아래로 투명해진다.
 * 고르기 전 폴더는 목록처럼 기본 회색이다.
 * 배너에는 글자가 없고 히어로 카드가 겹쳐 올라오므로 연한 색이어도 읽기 문제가 없다.
 */
export const getFolderHeroGradient = (folder: { color?: FolderColor }) => {
  const rgb = hexToRgbString(folderColorHex(folder.color));

  return `linear-gradient(180deg, rgb(${rgb}) 60%, rgba(${rgb}, 0) 100%)`;
};
